import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { KoobTooltip } from '@koob/ui';

export default function ExportShareButton({ shareUrl, disabled = false }) {
  const { t } = useTranslation('tripDesigner');
  const [copied, setCopied] = useState(false);

  const copyLink = async () => {
    await navigator.clipboard.writeText(shareUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  // A draft holding products the DMC no longer distributes cannot be shared:
  // the traveller would be handed a diary with holes in it.
  if (disabled) {
    return (
      <KoobTooltip tip={t('productAccess.shareDisabled')} side="left">
        <button
          className="h-14 w-14 rounded-full border-none shadow-k flex justify-center items-center bg-gray-300 cursor-not-allowed"
          type="button"
          aria-disabled
        >
          <i className="fa-regular fa-share-nodes text-lg text-white" />
        </button>
      </KoobTooltip>
    );
  }

  return (
    <button
      onClick={copyLink}
      className="h-14 w-14 rounded-full shadow-k flex justify-center items-center transition bg-blue-500 hover:bg-blue-600 cursor-pointer"
      type="button"
      title={copied ? 'Link copied!' : 'Copy share link'}
    >
      <i
        className={`fa-regular ${copied ? 'fa-check' : 'fa-share-nodes'} text-lg text-white`}
      />
    </button>
  );
}
